import React from 'react';

/** A small pill action in the sheet's header strip (Copy, …). */
export const PageAction: React.FC<{
  icon: React.ComponentType<{ size?: number }>;
  label: string;
  onClick: () => void;
}> = ({ icon: Icon, label, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="inline-flex cursor-pointer items-center gap-1 rounded-full border-none bg-surface-container-low px-2.5 py-1 font-body text-[0.6875rem] font-semibold text-on-surface-variant transition-transform duration-150 hover:bg-surface-container active:scale-[0.92]"
  >
    <Icon size={12} />
    {label}
  </button>
);

/**
 * A sheet of notebook paper for the transcription (mobile's NotePage): white
 * page, soft red margin rule, and a ruled header strip holding the label and
 * page actions. Plain and roomy inside — this is where the reading happens.
 */
export const NoteSheet: React.FC<{ label: string; actions?: React.ReactNode; children: React.ReactNode }> = ({
  label,
  actions,
  children,
}) => (
  <div className="pb-card relative -mx-2 rounded-xl pb-3 pl-[calc(1rem+1.25rem)] pr-4 pt-3 md:mx-0 md:pl-[calc(2.5rem+1.5rem)] md:pr-8 md:pt-4">
    <span
      aria-hidden
      className="pointer-events-none absolute bottom-0 left-4 top-0 w-[1.5px] bg-[rgba(142,50,22,0.28)] md:left-10"
    />
    <div className="flex min-h-8 items-center justify-between border-b border-solid border-outline-variant pb-2">
      <span className="pb-eyebrow">{label}</span>
      <div className="flex gap-2">{actions}</div>
    </div>
    <div className="pt-3">{children}</div>
  </div>
);
